export default __webpack_public_path__ + "static/minebest-66086465e6ad924c34dfce64f6492877.mp4";